import { ApiClient } from '@webapp/core/services/ApiClient'
import { SlackIntegrationRepository } from './SlackIntegrationRepository'

export const slackIntegrationRepository = new SlackIntegrationRepository({
  httpClient: ApiClient,
})

export type { ISlackIntegrationRepository } from '@webapp/platform/integrations/business-logic/interfaces/ISlackIntegrationRepository'
